import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import "rxjs/add/observable/throw";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import "rxjs/add/operator/mergeMap";
import { Observable } from "rxjs/Observable";
import { Cookie } from '../../utils/cookie';
import { TmCart } from '../model/cart';
import { TmErrorInfo } from '../model/error';
import { TmCartInstallmentRequest, TmCartLineRequest, TmCartPromocodeRequest, TmCartProvincialTaxRequest } from '../model/request/cart-request';
import { ApiBase } from './apibase.service';




export class CartBase extends ApiBase {
    protected cartBaseUrl = this.baseUrl + "/carts";
    protected cartUrlWithGuid = this.cartBaseUrl + "/" + this.cartGuid;

    constructor(protected http: Http) {
        super(http);
    }
}(CartBase as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Cart extends CartBase {

    constructor(protected http: Http) {
        super(http);
    }

    /** @description Returns cart details for given cartguid
      *   @return {TmCart}  
      */
    get(cartGuid: string): Observable<TmCart> {
        if (cartGuid === undefined) {
            let cookie = new Cookie();
            cookie.CartProductCount = "0";
            return Observable.throw("cartguid not found");
        }
        return this.http
            .get(this.cartBaseUrl + "/" + cartGuid, { headers: this.headers })
            .map((r: Response) => r.json() as TmCart);
    }


    /** @description Creates new cart and adds item to it.
    *   @return {TmCart}  
    */
    post(cartLine: TmCartLineRequest): Observable<TmCart> {
        let cookie = new Cookie();
        return this.getAppToken()
            .map(tokenResp => tokenResp)
            .flatMap(accessToken => {
                return this.http.post(this.cartBaseUrl, cartLine, { headers: this.appTokenJsonTypeHeader })
                    .map(cartData => cartData.json() as TmCart)
                    .catch(cartResp => {
                        if (cartResp.status === 401) {
                            return this.createAppToken()
                                .flatMap(token => {
                                    cookie.AppToken = token.json().access_token;
                                    return this.http.post(this.cartBaseUrl, cartLine, { headers: this.appTokenJsonTypeHeader });
                                })
                                .map(cartData => cartData.json() as TmCart);
                        }
                        else if (cartResp.status === 417) {
                            let errorInfo: TmErrorInfo = (cartResp.json() as TmErrorInfo[])[0];
                            return (Observable.throw(errorInfo.Message));
                        } else {
                            return (Observable.throw(cartResp.json()));
                        }
                    })
            });
    }

}(Cart as any).ctorParameters = function () { return [ { type: Http } ]; }


export class CartLine extends CartBase {
    private cartLineUrl = this.cartUrlWithGuid + "/cartlines";

    constructor(protected http: Http) {
        super(http);
    }

    /** @description Adds item to given cart. 
    *   @return {TmCart}  
    */
    post(cartLine: TmCartLineRequest): Observable<TmCart> {
        let cookie = new Cookie();
        if (cookie.CartGuid === undefined) {
            return Observable.throw("cartguid not found");
        }
        return this.getAppToken()
            .map(tokenResp => tokenResp)
            .flatMap(accessToken => {
                return this.http.post(this.cartLineUrl, cartLine, { headers: this.appTokenJsonTypeHeader })
                    .map(cartData => cartData.json() as TmCart)
                    .catch(cartResp => {
                        if (cartResp.status === 401) {
                            return this.createAppToken()
                                .flatMap(token => {
                                    cookie.AppToken = token.json().access_token;
                                    return this.http.post(this.cartLineUrl, cartLine, { headers: this.appTokenJsonTypeHeader });
                                })
                                .map(cartData => cartData.json() as TmCart);
                        }
                        else if (cartResp.status === 417) {
                            let errorInfo: TmErrorInfo = (cartResp.json() as TmErrorInfo[])[0];
                            return (Observable.throw(errorInfo.Message));
                        } else {
                            return (Observable.throw(cartResp.json()));
                        }
                    })
            });
    }

    /** @description Delete items from given cart. 
    *   @return {TmCart}  
    */

    delete(lineId: number): Observable<TmCart> {
        const url = `${this.cartLineUrl}/${lineId}`;
        let cookie = new Cookie();
        if (cookie.CartGuid === undefined) {
            return Observable.throw("cartguid not found");
        }
        return this.getAppToken()
            .map(tokenResp => tokenResp)
            .flatMap(accessToken => {
                return this.http.delete(url, { headers: this.appTokenJsonTypeHeader })
                    .map(cartData => cartData.json() as TmCart)
                    .catch(cartResp => {
                        if (cartResp.status === 401) {
                            return this.createAppToken()
                                .flatMap(token => {
                                    cookie.AppToken = token.json().access_token;
                                    return this.http.delete(url, { headers: this.appTokenJsonTypeHeader })
                                })
                                .map(cartData => cartData.json() as TmCart);
                        }
                        else if (cartResp.status === 417) {
                            let errorInfo: TmErrorInfo = (cartResp.json() as TmErrorInfo[])[0];
                            return (Observable.throw(errorInfo.Message));
                        } else {
                            return (Observable.throw(cartResp.json()));
                        }
                    })
            });
    }
}(CartLine as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Cart_Promocode extends CartBase {
    private cartPromoUrl = this.cartUrlWithGuid + "/promocode";

    constructor(protected http: Http) {
        super(http);
    }

    /** @description Apply promocode to given cart.
    *   @return {TmCart}  
    */
    put(promoReq: TmCartPromocodeRequest): Observable<TmCart> {
        let cookie = new Cookie();
        if (cookie.CartGuid === undefined) {
            return Observable.throw("cartguid not found");
        }
        return this.getAppToken()
            .map(tokenResp => tokenResp)
            .flatMap(accessToken => {
                return this.http.put(this.cartPromoUrl, promoReq, { headers: this.appTokenJsonTypeHeader })
                    .map(cartData => cartData.json() as TmCart)
                    .catch(cartResp => {
                        if (cartResp.status === 401) {
                            return this.createAppToken()
                                .flatMap(token => {
                                    cookie.AppToken = token.json().access_token;
                                    return this.http.put(this.cartPromoUrl, promoReq, { headers: this.appTokenJsonTypeHeader });
                                })
                                .map(cartData => cartData.json() as TmCart);
                        }
                        else if (cartResp.status === 417) {
                            let errorInfo: TmErrorInfo = (cartResp.json() as TmErrorInfo[])[0];
                            return (Observable.throw(errorInfo.Message));
                        } else {
                            return (Observable.throw(cartResp.json()));
                        }
                    })
            });
    }

    /** @description Delete promocode from given cart. 
    *   @return {TmCart}  
    */

    delete(): Observable<TmCart> {
        let cookie = new Cookie();
        if (cookie.CartGuid === undefined) {
            return Observable.throw("cartguid not found");
        }
        return this.getAppToken()
            .map(tokenResp => tokenResp)
            .flatMap(accessToken => {
                return this.http.delete(this.cartPromoUrl, { headers: this.appTokenJsonTypeHeader })
                    .map(cartData => cartData.json() as TmCart)
                    .catch(cartResp => {
                        if (cartResp.status === 401) {
                            return this.createAppToken()
                                .flatMap(token => {
                                    cookie.AppToken = token.json().access_token;
                                    return this.http.delete(this.cartPromoUrl, { headers: this.appTokenJsonTypeHeader })
                                })
                                .map(cartData => cartData.json() as TmCart);
                        }
                        else if (cartResp.status === 417) {
                            let errorInfo: TmErrorInfo = (cartResp.json() as TmErrorInfo[])[0];
                            return (Observable.throw(errorInfo.Message));
                        } else {
                            return (Observable.throw(cartResp.json()));
                        }
                    })
            });
    }
}(Cart_Promocode as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Cart_Installment extends CartBase {
    private cartInstallmentUrl = this.cartUrlWithGuid + "/installment";

    constructor(protected http: Http) {
        super(http);
    }

    /** @description Update number of installments for given cart. 
    *   @return {TmCart}  
    */
    put(installmentReq: TmCartInstallmentRequest): Observable<TmCart> {
        let cookie = new Cookie();
        if (cookie.CartGuid === undefined) {
            return Observable.throw("cartguid not found");
        }
        return this.getAppToken()
            .map(tokenResp => tokenResp)
            .flatMap(accessToken => {
                return this.http.put(this.cartInstallmentUrl, installmentReq, { headers: this.appTokenJsonTypeHeader })
                    .map(cartData => cartData.json() as TmCart)
                    .catch(cartResp => {
                        if (cartResp.status === 401) {
                            return this.createAppToken()
                                .flatMap(token => {
                                    cookie.AppToken = token.json().access_token;
                                    return this.http.put(this.cartInstallmentUrl, installmentReq, { headers: this.appTokenJsonTypeHeader });
                                })
                                .map(cartData => cartData.json() as TmCart);
                        }
                        else if (cartResp.status === 417) {
                            let errorInfo: TmErrorInfo = (cartResp.json() as TmErrorInfo[])[0];
                            return (Observable.throw(errorInfo.Message));
                        } else {
                            return (Observable.throw(cartResp.json()));
                        }
                    })
            });
    }
}(Cart_Installment as any).ctorParameters = function () { return [ { type: Http } ]; }


export class Cart_ProvincialTaxes extends CartBase {
    private cartProvincialTaxesUrl = this.cartUrlWithGuid + "/provincialtaxes";

    constructor(protected http: Http) {
        super(http);
    }

    /** @description Update shipping province of given cart to recalculate taxes.
    *   @return {TmCart}  
    */
    put(taxtReq: TmCartProvincialTaxRequest): Observable<TmCart> {
        let cookie = new Cookie();
        if (cookie.CartGuid === undefined) {
            return Observable.throw("cartguid not found");
        }
        return this.getAppToken()
            .map(tokenResp => tokenResp)
            .flatMap(accessToken => {
                return this.http.put(this.cartProvincialTaxesUrl, taxtReq, { headers: this.appTokenJsonTypeHeader })
                    .map(cartData => cartData.json() as TmCart)
                    .catch(cartResp => {
                        if (cartResp.status === 401) {
                            return this.createAppToken()
                                .flatMap(token => {
                                    cookie.AppToken = token.json().access_token;
                                    return this.http.put(this.cartProvincialTaxesUrl, taxtReq, { headers: this.appTokenJsonTypeHeader });
                                })
                                .map(cartData => cartData.json() as TmCart);
                        }
                        else if (cartResp.status === 417) {
                            let errorInfo: TmErrorInfo = (cartResp.json() as TmErrorInfo[])[0];
                            return (Observable.throw(errorInfo.Message));
                        } else {
                            return (Observable.throw(cartResp.json()));
                        }
                    })
            });
    }
}(Cart_ProvincialTaxes as any).ctorParameters = function () { return [ { type: Http } ]; }



export class Carts_ProductCount extends CartBase {

    constructor(protected http: Http) {
        super(http);
    }

    /** @description Returns total number of items in a given cart.
    *   @return {string}  
    */
    get(): Observable<string> {
        if (this.cartGuid === undefined) {
            return Observable.of("0");
        }
        return this.http
            .get(this.cartUrlWithGuid + "/productcount", { headers: this.headers })
            .map((r: Response) => r.json() as string);
    }
}(Carts_ProductCount as any).ctorParameters = function () { return [ { type: Http } ]; }



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../tscapi/service/cart.service.ts